import { render, staticRenderFns } from "./BroadcastMessageList.vue?vue&type=template&id=987bab1e&scoped=true&"
import script from "./BroadcastMessageList.vue?vue&type=script&lang=js&"
export * from "./BroadcastMessageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987bab1e",
  null
  
)

export default component.exports